// @flow
import { PRODUCT_SERVICES } from 'Client/cms/toolkit/constants';
import { ProductServicesLine } from 'Components/lines/product-services-line/ProductServicesLine';
import { productServicesResolver } from './productServices.resolver';

export const productServicesDescriptor = {
  name: PRODUCT_SERVICES,
  component: ProductServicesLine,
  resolve: productServicesResolver.resolve,
};
